@if (event && visual) {
  @if (gridView === GridView.TILE) {
    <div
      class="event-card"
      [ngStyle]="{
        'background-image': 'url(' + encodedMainImage() + ')',
        'background-color': visual.backgroundColor
      }"
      (click)="goToEvent()"
    >
      <div class="info-overlay">
        <div class="top-info">
          <div class="rsvp-info">
            @if (event.isUserHost(loggedUserId)) {
              <div class="host-icon">
                <i class="fa-solid fa-user-crown"></i>
              </div>
            } @else if (loggedUserId) {
              <div class="rsvp-title">
                {{ event.getUserRSVPTitle(loggedUserId) | translate }}
              </div>
            }
          </div>
        </div>

        <div class="bottom-info">
          <div class="event-info">
            <div class="date-info">{{ getEventDateInfoForCard() }}</div>
            <div class="event-name">{{ event.name }}</div>
          </div>

          <div class="host-info">
            <app-user-avatar
              [user]="event.hostUser"
              [size]="32"
              [placeholderFontSize]="14"
            ></app-user-avatar>
            <span class="host-name">{{ event.hostUser?.name }}</span>
          </div>
        </div>
      </div>

      @if (event.isMainPictureVideo()) {
        <div class="background-video-cont">
          <video
            class="key-visual-1"
            [muted]="'muted'"
            autoplay
            playsinline
            loop
          >
            <source [src]="event.mainPictureUrl" type="video/mp4" />
          </video>
        </div>
      }

      @if (showActionBar && event.isUserHost(loggedUserId)) {
        <div class="action-bar">
          <div class="action" (click)="onLink($event)">
            <i class="fal fa-link"></i>
            {{ "APP.LINK" | translate }}
          </div>
          <div class="action" (click)="onDuplicate($event)">
            <i class="fal fa-copy"></i>
            {{ "APP.DUPLICATE" | translate }}
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="event-card list-view" (click)="goToEvent()">
      @if (event.isMainPictureVideo()) {
        <div class="background-video-cont event-image">
          <video
            class="key-visual-1"
            [muted]="'muted'"
            autoplay
            playsinline
            loop
          >
            <source [src]="event.mainPictureUrl" type="video/mp4" />
          </video>
        </div>
      } @else {
        <div
          class="event-image"
          [ngStyle]="{
            'background-image': 'url(' + encodedMainImage() + ')',
            'background-color': visual.backgroundColor
          }"
        >
          <div class="rsvp-info">
            @if (event.isUserHost(loggedUserId)) {
              <div class="host-icon">
                <i class="fa-solid fa-user-crown"></i>
              </div>
            } @else if (loggedUserId) {
              @if (getRSVPTitle()) {
                <div class="rsvp-title" [ngStyle]="getRSVPTitleStyles()">
                  {{ getRSVPTitle() || "" | translate }}
                </div>
              }
            }
          </div>
        </div>
      }

      <div class="event-info-section">
        <div class="bottom-info">
          <div class="event-info">
            <div class="date-info">{{ getEventDateInfoForCard() }}</div>
            <div class="event-name">{{ event.name }}</div>
          </div>

          <div class="item-info">
            <i class="fas fa-map-marker-alt"></i>
            <span class="item-name">
              @if (event.getAddressDisplayNameSecondary() !== "-") {
                {{ event.getAddressDisplayNameSecondary() }} |
              }
              {{ event.getAddressDisplayNamePrimary() }}
            </span>
          </div>

          <div class="item-info">
            <i class="fa-solid fa-crown"></i>
            <span class="item-name"
              >{{ event.hostUser?.name }}
              @if (event.hostUser?.id === loggedUserId) {
                ({{ "APP.YOU" | translate }})
              }
            </span>
          </div>
          <div class="bottom-section">
            @if (event.attendees && event.attendees.length > 1) {
              <div class="attendees">
                <app-event-attendees
                  [event]="event"
                  [avatarSize]="24"
                  [avatarPlaceholderFontSize]="12"
                  [maxNumber]="3"
                  [eventCardView]="true"
                ></app-event-attendees>
                {{
                  "APP.YOU_AND_MORE"
                    | translate
                      : {
                          number: formatCompactNumber(
                            event.attendees.length - 1
                          )
                        }
                }}
              </div>
            }
            <div class="tickets-section">
              @if (event.cheapestTicketPriceInCents && !event.isInThePast()) {
                <i class="fa-solid fa-ticket"></i>
                @if (event.cheapestTicketPriceInCents === 0) {
                  {{ "APP.TICKETS_EDIT.FREE" | translate }}
                } @else {
                  {{ "APP.FROM" | translate }}
                  {{ event.getCheapestTicketPrice() }}
                }
              }
            </div>
          </div>
        </div>
      </div>

      @if (showActionBar && event.isUserHost(loggedUserId)) {
        <div class="action-bar">
          <div class="action" (click)="onLink($event)">
            <i class="fal fa-link"></i>
            {{ "APP.LINK" | translate }}
          </div>
          <div class="action" (click)="onDuplicate($event)">
            <i class="fal fa-copy"></i>
            {{ "APP.DUPLICATE" | translate }}
          </div>
        </div>
      }
    </div>
  }
}
